import { render } from "./yjbg.vue?vue&type=template&id=955ef48a&scoped=true&ts=true"
import script from "./yjbg.vue?vue&type=script&lang=ts"
export * from "./yjbg.vue?vue&type=script&lang=ts"

import "./yjbg.vue?vue&type=style&index=0&id=955ef48a&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-955ef48a"]])

export default __exports__